import { createActions, handleActions } from 'redux-actions';

import * as loadingStates from '@coconut/constants/loadingState';

export const types = {
  RATE_QUESTION: 'RATE_QUESTION',
  RATE_QUESTION_SUCCESS: 'RATE_QUESTION_SUCCESS',
  RATE_QUESTION_FAILED: 'RATE_QUESTION_FAILED',
};

export const { rateQuestion, rateQuestionSuccess, rateQuestionFailed } =
  createActions(
    {
      [types.RATE_QUESTION]: ({
        userId,
        questionId,
        score,
        comment,
        messageId,
      }) => ({
        userId,
        questionId,
        score,
        comment,
        messageId,
      }),
      [types.RATE_QUESTION_FAILED]: (errorMessage) => ({ errorMessage }),
    },
    types.RATE_QUESTION_SUCCESS
  );

const INIT_STATE = {
  loadingStatus: loadingStates.EMPTY,
  errorMessage: '',
};

const reducer = handleActions(
  {
    [types.RATE_QUESTION]: (state) => ({
      ...state,
      loadingStatus: loadingStates.LOADING,
    }),
    [types.RATE_QUESTION_SUCCESS]: (state) => ({
      ...state,
      loadingStatus: loadingStates.READY,
    }),
    [types.RATE_QUESTION_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingStates.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getLoadingStatus = (state) => state.rateQuestion.loadingStatus;



// WEBPACK FOOTER //
// ./src/services/redux/rate.js